const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');


const VerticalAccordion = ({ children, className, selectedIndex }) => (
    <div className={classNames('vertical-accordion', className)}>
        {React.Children.map(children, child => {
            if (child.props.viewIndex !== undefined && child.props.viewIndex !== selectedIndex) {
                return
            } else return child;
        })}
    </div>
);


VerticalAccordion.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    selectedIndex: PropTypes.number,
};


module.exports = VerticalAccordion;
